import { connect } from 'react-redux'
import PendingTeachers from './pending-teachers'
import {
  getFetchSchoolTeamRequest,
  getPendingTeachersList
} from '../../../../../stores/school-team/school-team.selectors'

const mapStateToProps = state => {
  return {
    pending: getFetchSchoolTeamRequest(state).pending,
    pendingTeachers: getPendingTeachersList(state) || []
  }
}

export default connect(
  mapStateToProps,
  null
)(PendingTeachers)
